declare global {
  interface Window {
    gtag: (...args: any[]) => void
  }
}
function gtagEvent(eventName: string, params = {}) {
  if (!window.gtag) return
  window.gtag('event', eventName, params)
}

/**
 * add all event name here
 */
const CUSTOM_EVENT = {
  BUTTON_CLICKED: 'button_clicked',
  TRAILER_PLAYED: 'trailer_played'
}

export function buttonClicked(buttonText: string, componentName: string) {
  gtagEvent(CUSTOM_EVENT.BUTTON_CLICKED, {
    button_text: buttonText,
    component: componentName
  })
}

export function trailerPlayed(componentName: string) {
  gtagEvent(CUSTOM_EVENT.TRAILER_PLAYED, { component: componentName })
}
